export interface Schedule {
	id: number;
	dayOfWeek: string;
	startTime: string;
	endTime: string;
	clinicId: number;
}

export interface ScheduleEdit extends Schedule {
	isEdit: boolean;
	isDelete: boolean;
}

export interface GetSchedulesResponse {
	schedules: Schedule[];
}

export enum DayOfWeek {
	Sunday = "Sunday",
	Monday = "Monday",
	Tuesday = "Tuesday",
	Wednesday = "Wednesday",
	Thursday = "Thursday",
	Friday = "Friday",
	Saturday = "Saturday",
}
